import facebook from "../../src/images/refer_facebook.png";
import twitter from "../../src/images/refer_twitter.png";
import instagram from "../../src/images/refer_Instagram.png";
import line from "../../src/images/refer_Line.png";

export const SELECTED_SO_CODE_JPNO = "JPNO";

export const socialPlatforms = [
    {
        name: "Facebook",
        url: "http://www.facebook.com/WorldVisionJapan",
        icon: facebook,
        eventName: "RecommendedPopupFacebookBtn",
    },
    {
        name: "Twitter",
        url: "https://x.com/WorldVisionJPN",
        icon: twitter,
        eventName: "RecommendedPopuphandleTwitterBtn",
    },
    {
        name: "Instagram",
        url: "https://www.instagram.com/worldvisionjapan/",
        icon: instagram,
        eventName: "RecommendedPopuphandleInstagramBtn",
    },
    {
        name: "Line",
        url: "https://worldvisionjapan.page.link/9i5w",
        icon: line,
        eventName: "RecommendedPopuphandleLineBtn",
    },
];
